var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 2368 \\u2013 15",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "trash-can (3)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144612",
    transform: "translate(9.571 9.714)",
    style: {
      fill: "#e32a34"
    },
    d: "M0 0h1.143v6.857H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144613",
    transform: "translate(13 9.714)",
    style: {
      fill: "#e32a34"
    },
    d: "M0 0h1.143v6.857H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21059",
    d: "M4 6v1.143h1.143v11.428a1.143 1.143 0 0 0 1.143 1.143h9.143a1.143 1.143 0 0 0 1.143-1.143V7.143h1.143V6zm2.286 12.571V7.143h9.143v11.428z",
    transform: "translate(1 .286)",
    style: {
      fill: "#e32a34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144614",
    transform: "translate(9.571 4)",
    style: {
      fill: "#e32a34"
    },
    d: "M0 0h4.571v1.143H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNewIcon);
export default __webpack_public_path__ + "static/media/DeleteNewIcon.0053e2d7e27b3753aac53c02ccacfa7d.svg";
export { ForwardRef as ReactComponent };